import {
    DECREMENT_PRODUCT_PAGE,
    GET_FEATURED_PRODUCT_LIST,
    GET_LATEST_PRODUCT_LIST,
    GET_PRODUCT_DETAILS,
    GET_PRODUCT_LIST,
    GET_SIMILAR_PRODUCTS,
    INCREMENT_PRODUCT_PAGE,
    SET_CATEGORY_FILTER,
    SET_PRODUCT_ATTRIBUTE_FILTER,
    SET_PRODUCT_BRAND_FILTER,
    SET_PRODUCT_LIMIT,
    SET_PRODUCT_PAGE,
    SET_PRODUCT_PRICE_FILTER,
    SET_PRODUCT_SEARCH_FILTER,
    SET_PRODUCT_SORT_FILTER
} from "../action_types";

export const getFeaturedProductList = (params) => {
    return {
        type: GET_FEATURED_PRODUCT_LIST,
        api: true,
        payload: params
    }
};

export const getProductList = (params) => {
    return {
        type: GET_PRODUCT_LIST,
        api: true,
        payload: params
    }
}

export const getLatestProductList = () => {
    return {
        type: GET_LATEST_PRODUCT_LIST,
        api: true,
    }
}

export const getProductDetails = (slugOrId) => {
    return {
        type: GET_PRODUCT_DETAILS,
        api: true,
        payload: slugOrId,
    }
}

export const setProductPage = (page) => {
    return {
        type: SET_PRODUCT_PAGE,
        payload: page
    }
}

export const incrementProductPage = () => {
    return {
        type: INCREMENT_PRODUCT_PAGE,
    }
}

export const decrementProductPage = () => {
    return {
        type: DECREMENT_PRODUCT_PAGE,
    }
}

export const setProductLimit = (limit) => {
    return {
        type: SET_PRODUCT_LIMIT,
        payload: limit
    }
}

export const setCategoryFilter = (categoryId) => {
    return {
        type: SET_CATEGORY_FILTER,
        payload: categoryId
    }
}

export const setProductSearchFilter = (search) => {
    return {
        type: SET_PRODUCT_SEARCH_FILTER,
        payload: search
    }
}

export const setProductPriceFilter = ({ min = null, max = null } = {}) => {
    return {
        type: SET_PRODUCT_PRICE_FILTER,
        payload: { min, max },
    }
}

// Stores the list of selected attribute option ids used to filter the product
// list. Always normalised to an array of numbers so the reducer/endpoint can
// rely on the shape.
export const setProductAttributeFilter = (optionIds = []) => {
    return {
        type: SET_PRODUCT_ATTRIBUTE_FILTER,
        payload: Array.isArray(optionIds) ? optionIds : [],
    }
}

// Stores the selected sort option (sent to the API as `sort_by`). `null`/empty
// means no explicit sort.
export const setProductSortFilter = (sort = null) => {
    return {
        type: SET_PRODUCT_SORT_FILTER,
        payload: sort === '' || sort === undefined ? null : sort,
    }
}

// Stores the selected brand (partner) id used to filter the product list.
// `null` means no brand filter.
export const setProductBrandFilter = (brandId = null) => {
    return {
        type: SET_PRODUCT_BRAND_FILTER,
        payload: brandId === '' || brandId === undefined ? null : brandId,
    }
}

export const getSimilarProducts = (id) => {
    return {
        type: GET_SIMILAR_PRODUCTS,
        api: true,
        payload: id,
    }
}